<template>
  <div class="datav-map-event-list">
    <transition-group name="el-zoom-in-center">
      <div v-for="(item, index) in equipEvent" :key="item.eventid" class="flex align-items-center card" :style="{ 'transition-delay': 0.1 * index + 's' }">
        <div class="hd pl-sm">
          <img v-if="item.type === 'online' || item.type === '上线'" class="image small" src="@/assets/line-on.png" />
          <img v-else-if="item.type === 'offline' || item.type === '掉线'" class="image small" src="@/assets/line-off.png" />
          <img v-else-if="item.type === 'turnon' || item.type === '开机'" class="image small" src="@/assets/turn-on.png" />
          <img v-else-if="item.type === 'turnoff' || item.type === '关机'" class="image small" src="@/assets/turn-off.png" />
          <img v-else-if="item.type === 'alarmon' || item.type === '告警'" class="image small" src="@/assets/warn-on.png" />
          <img v-else-if="item.type === 'alarmoff' || item.type === '告警解除'" class="image small" src="@/assets/warn-off.png" />
        </div>
        <div class="ml bd ellipsis">
          <span>{{ item.content }}</span>
        </div>
        <div class="ft pr-sm">
          <el-link class="dark-link" :underline="false" @click="emitClick(item)" @mouseenter.native="emitHover(item)">{{ maskName(item) }}</el-link>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { getEquipLatestEventListApi } from '@/api/rms/rmsEventApi'
import { goFilter } from '@/utils/common'
export default {
  props: {
    isMasked: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      query: {
        num: 10
      },
      equipEvent: [],

      timerId: null,
      pingCounter: 0,
      pingCt: 5,
    }
  },

  created() {
    this.getRecentEquipEvent()
    this.initInterval()
  },

  beforeDestroy() {
    this.stopInterval()
  },

  methods: {
     maskName(row) {
      return this.isMasked ? goFilter(row.go) : row.equip_name
    },

    initInterval() {
      var _this = this
      _this.pingCounter = 0
      _this.stopInterval()
      this.timerId = setInterval(function() {
        // 周期ping
        _this.pingCounter += 1
        if (_this.pingCounter >= _this.pingCt) {
          _this.pingCounter = 0
          _this.getRecentEquipEvent()
        }
      }, 1000)
    },
    stopInterval() {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = null
      }
    },

    getRecentEquipEvent() {
      getEquipLatestEventListApi(this.query).then(res => {
        if (!res.errno) {
          this.equipEvent = res.data.list
        }
      })
    },

    emitClick(item) {
      this.$emit('equip-click', item.equipid)
    },

    emitHover(item) {
      this.$emit('equip-hover', item.equipid)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-top: 10px;
  padding: 8px 10px 7px 10px;
  border-radius: 5px;
  background-color: rgba(128, 128, 128, .1);
  transition-duration: .5s;
  transition-timing-function: ease-out;
}
</style>
